/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetAdvancedFilter {
    getFixupPrototypeFunction() { return BudgetAdvancedFilter.fixupPrototype; }

    static newInstance(model: Partial<BudgetAdvancedFilter>): BudgetAdvancedFilter {
        let obj = Object.assign(new BudgetAdvancedFilter(), model);
        BudgetAdvancedFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetAdvancedFilter>): BudgetAdvancedFilter {
        if (!model) return null;
        return BudgetAdvancedFilter.newInstance(<BudgetAdvancedFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetAdvancedFilter) {
        if (!obj) return;

        models.BudgetAdvancedFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetAdvancedFilter): boolean {
        Object.setPrototypeOf(obj, BudgetAdvancedFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.BudgetAdvancedFilterDetails.fixupPrototype(val);
            }
        }
        if (this.compartments) {
            for (let val of this.compartments) {
                models.BudgetAdvancedFilterDetails.fixupPrototype(val);
            }
        }
        if (this.regions) {
            for (let val of this.regions) {
                models.BudgetAdvancedFilterDetailsRegions.fixupPrototype(val);
            }
        }
    }

    tags: Array<models.BudgetAdvancedFilterDetails>;

    compartments: Array<models.BudgetAdvancedFilterDetails>;

    regions: Array<models.BudgetAdvancedFilterDetailsRegions>;

}
